export default __webpack_public_path__ + "static/media/Tiktok.730b0962.png";